import MotionEnter from "../../../../../utils/animation/motion/MotionEnter";
import PageBuilder from "../page/PageBuilder";
import PageDashboard from "../page/PageDashboard";
import PageMarketing from "../page/PageMarketing";
import PagePeople from "../page/PagePeople";
import PageProducts from "../page/PageProducts";
import PageProposals from "../page/PageProposals";
import PageSettings from "../page/PageSettings";

export default [
  {
    path: "/wealth-admin-portal/dashboard",
    Component: () => (
      <MotionEnter>
        <PageDashboard />
      </MotionEnter>
    ),
  },
  {
    path: "/wealth-admin-portal/people",
    Component: () => (
      <MotionEnter>
        <PagePeople />
      </MotionEnter>
    ),
  },
  {
    path: "/wealth-admin-portal/proposals",
    Component: () => (
      <MotionEnter>
        <PageProposals />
      </MotionEnter>
    ),
  },
  {
    path: "/wealth-admin-portal/builder",
    Component: () => (
      <MotionEnter>
        <PageBuilder />
      </MotionEnter>
    ),
  },
  {
    path: "/wealth-admin-portal/products",
    Component: () => (
      <MotionEnter>
        <PageProducts />
      </MotionEnter>
    ),
  },
  {
    path: "/wealth-admin-portal/marketing",
    Component: () => (
      <MotionEnter>
        <PageMarketing />
      </MotionEnter>
    ),
  },
  {
    path: "/wealth-admin-portal/settings",
    Component: () => (
      <MotionEnter>
        <PageSettings />
      </MotionEnter>
    ),
  },
];
